export const formErrorHandler = (message) => {
   if(message.includes('unique')) {
      return 'Эта почта уже используется, введите другую'
   } else {
      return 'Что-то пошло не так, перезагрузите страницу и попробуйте снова'
   }
}
